import React from "react";
import styles from "./DropDownBar.module.css";

import logo from "../assets/logo/logo.svg";
function DropDownBar({ inicio, dropDownMenu }) {
  return (
    <div className={styles.menu}>
      <button className={styles.lines} onClick={dropDownMenu}>
        <div className={styles.line}></div>
        <div className={styles.line}></div>
        <div className={styles.line}></div>
      </button>
      <img src={logo} alt="logo" className={styles.logo} onClick={inicio}></img>
    </div>
  );
}

export { DropDownBar };
